import { useTranslation } from 'react-i18next';

import RichTextEditor from '@/common/components/RichTextEditor';

interface AddNoteFormProps {
  title: string;
  content: string;
  onTitleChange: (title: string) => void;
  onContentChange: (content: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  isSaving?: boolean;
}

const AddNoteForm = ({
  title,
  content,
  onTitleChange,
  onContentChange,
  onSubmit,
  onCancel,
  isSaving = false,
}: AddNoteFormProps) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <input
        className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder={t('notes.noteTitlePlaceholder')}
        type="text"
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
      />

      <RichTextEditor
        content={content}
        placeholder={t('notes.noteContentPlaceholder')}
        onChange={onContentChange}
      />

      <div className="flex justify-end gap-3">
        <button
          className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors disabled:opacity-50"
          disabled={isSaving}
          onClick={onCancel}
        >
          {t('common.cancel')}
        </button>
        <button
          className="px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50"
          disabled={isSaving}
          onClick={onSubmit}
        >
          {isSaving ? t('common.saving') : t('notes.saveNote')}
        </button>
      </div>
    </div>
  );
};

export default AddNoteForm;
